// extracted by mini-css-extract-plugin
module.exports = {"supplier_manager":"tax_supplier_manager__2yA6R","card":"tax_card__Q6Ezp"};